const translations = {
  navigation: {
    table: 'Table',
    customers: 'Customers',
    stats: 'Stats',
    settings: 'Settings',
    logout: 'Logout'
  },
  label: {
    accept: 'Accept',
    or: 'or',
    first_name: 'First name',
    last_name: 'Last name',
    location: 'Location',
    address: 'Address',
    name: 'Name',
    person_name: 'Name',
    phone: 'Phone',
    email: 'Email',
    birthday: 'Birthday',
    city: 'City',
    note: 'Note',
    password: 'Password',
    password_confirmation: 'Password confirmation',
    search: 'Search',
    category: 'Category',
    allCustomers: 'All clients',
    organization: 'Organization name',
    chooseCurrency: 'Choose currency',
    chooseCountry: 'Choose country',
    businessPhone: 'Business phone',
    businessHours: 'Business hours',
    activate: 'Activate',
    deactivate: 'Deactivate',
    today: 'Today',
    categories: 'Categories',
    language: 'Language',
    stats: 'Stats',
    employees: 'Employees',
    account: 'Account',
    services: 'Services',
    materials: 'Materials',
    profile: 'Profile',
    delete: 'Delete',
    edit: 'Edit',
    newEmail: 'New email',
    repeatPassword: 'Repeat password',
    change: 'Change',
    addEmployee: 'Add employee',
    editEmployee: 'Edit employee',
    addCustomer: 'Add customer',
    editCustomer: 'Edit customer',
    newCategory: 'New category',
    originalProfit: 'Original Profit',
    country: 'Country',
    currency: 'Currency',
    about: 'About',
    unit: 'Unit',
    quantity: 'Quantity',
    price: 'Price',
    discount: 'Discount',
    total: 'Total',
    duration: 'Duration',
    pause: 'Pause',
    material: 'Material',
    date: 'Date',
    close: 'Close',
    noDataAvailable: 'No Data Available',
    addMaterial: 'Add material',
    editMaterial: 'Edit material',
    addService: 'Add service',
    editService: 'Edit service',
    actions: 'Actions',
    service: 'Service',
    serviceName: 'Service name',
    materialName: 'Material name',
    h: 'h',
    min: 'min',
    noPause: 'No pause',
    ml: 'ml',
    g: 'g',
    none: 'None',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    requestedChange: 'Requested',
    invitation: 'Invitation',
    view: 'View',
    addAppointment: 'Add appointment',
    customer: 'Customer',
    customerInfo: 'Customer Info',
    customerHistory: 'Customer History',
    noCustomer: 'No Customer',
    manageOrganization: 'Administrator',
    from: 'From',
    to: 'To',
    topWorkers: 'Top Workers',
    perProfit: 'Per Profit',
    perCustomers: 'Per Customers',
    created: 'Created',
    updated: 'Updated',
    profit: 'Profit',
    appointments: 'Appointments',
    notifications: 'Notifications'
  },
  dateTime: {
    months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec',
    days: 'Mon_Tue_Wed_Thu_Fri_Sat_Sun'
  },
  days: {
    0: 'Monday',
    1: 'Tuesday',
    2: 'Wednesday',
    3: 'Thursday',
    4: 'Friday',
    5: 'Saturday',
    6: 'Sunday'
  },
  button: {
    back: 'Back',
    login: 'Login',
    forgotPassword: 'Forgot Password',
    facebookLogin: 'Facebook login',
    facebookConnect: 'Connect with facebook',
    facebookDisconnect: 'Disconnect with Facebook',
    register: 'Register',
    upload: 'Upload',
    remove: 'Remove',
    update: 'Update',
    cancel: 'Cancel',
    add: 'Add',
    save: 'Save',
    submit: 'Submit',
    invite: 'Invite',
    resendInvitation: 'Resend invitation',
    loadMore: 'Load more'
  },
  message: {
    cookiePolicy: 'This site uses cookies. By continuing to browse the site you are consenting to their use.',
    somethingWentWrong: 'Ups! Something went wrong',
    loginFailed: 'Failed to login. Please check your credentials',
    loginFailedEmailVerify: 'Failed to login. Please verify email address',
    login: 'Login',
    homepage: 'Homepage',
    register: 'Register',
    forgottenPassword: 'Forgotten password',
    facebookFailed: 'Failed to connect with Facebook',
    checkYourEmail: 'Please check your email for reset instructions',
    mailNotFound: 'Requested mail not found',
    saveSuccess: 'Data saved',
    saveFailed: 'Failed to save data',
    removed: 'Removed',

    areYouSure: 'Are you sure?',
    removeEmployee: 'This will remove employee',
    removeService: 'This will remove service',
    removeMaterial: 'This wil remove material',
    removeCustomer: 'This will remove customer',
    removeCategory: 'This will remove category',
    removeAppointment: 'This will remove appointment',
    badInvitation: 'Bad invitation',
    invitationSent: 'Invitation sent',
    joinedSalonize: 'Joined Salonize',
    emailChanged: 'Email address is changed',
    welcome: {
      welcomeSalonize: 'Welcome to Salonize!',
      followSteps: 'Lets\' get you all set up, follow 2 steps below.',
      firstStep: 'First you need to add your employees. ',
      secondStep: 'Then you need to add services '
    },
    no_notifications: 'No new notifications',
    hasBirthday: 'has birthday',
    passwordMismatch: 'Password mismatch',
    emailTaken: 'Email already taken',
    missingLocation: 'Missing location',
    noServices: 'No selected services'
  },
  languages: {
    en: 'English',
    rs: 'Српски',
    hr: 'Hrvatski',
    mk: 'Македонски',
    si: 'Slovenščina'
  },
  currencies: {
    eur: 'EUR',
    rsd: 'RSD',
    hrk: 'HRK',
    chf: 'CHF',
    gbp: 'GBP',
    usd: 'USD',
    all: 'ALL',
    bam: 'BAM',
    mkd: 'MKD'
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/translations/en.js